import React, {useEffect, useState} from 'react';
import {
  UserOutlined,
  BorderlessTableOutlined, IdcardOutlined, BarChartOutlined
} from '@ant-design/icons';
import {BiCopy, BiMoneyWithdraw, BiTransfer, BiTransferAlt} from 'react-icons/bi';
import { FiUsers } from 'react-icons/fi';
import { VscLiveShare } from 'react-icons/vsc';
import {
  Sider,
  Logo,
  TecpayLogo,
  Menu,
  SubMenu,
  Item,
  Link,
} from '../styles';
import { ISideMenuProps } from '../types';
import { RoutesEnum } from '../../../routes/types';
import {FaClipboardList, FaFileContract, FaHandHoldingUsd, FaHistory, FaRegFilePowerpoint} from "react-icons/fa";
import {FaFileCircleCheck, FaMobileScreenButton} from "react-icons/fa6";
import {CiMoneyBill, CiShoppingCart} from "react-icons/ci";
import {IConfigData} from "../../../store/config/types";
import { PortalPermissions, can, canAny } from "../../../config/permissions";
import logo from "../../../assets/tecpay-no-bg.png";
import {MdOutlinePointOfSale} from "react-icons/md";
import {LiaFileSignatureSolid} from "react-icons/lia";
import {GiReceiveMoney} from "react-icons/gi";

const SideMenu: React.FC<ISideMenuProps> = (props: ISideMenuProps) => {
  const { collapsed } = props;
  const [primaryColor, setPrimaryColor] = useState('');
  const [logoUrl, setLogoUrl] = useState('');

  useEffect(() => {
    const domain = window.location.hostname;
    const cachedConfig: IConfigData = JSON.parse(localStorage.getItem(`config_${domain}`) as string);
    if (cachedConfig) {
      setPrimaryColor(cachedConfig.corPrimaria);
      setLogoUrl(cachedConfig.linkImagem2);
    } else {
      setPrimaryColor('#0e2b27');
    }
  }, []);

  return (
    <Sider
      width={230}
      className="site-layout-background"
      trigger={null}
      collapsible
      collapsed={collapsed}
      style={{backgroundColor: primaryColor}}
    >
      <Logo to="/painel-de-vendas">
        <TecpayLogo src={logoUrl || logo} />
      </Logo>
      <Menu
        mode="inline"
        theme="dark"
        style={{backgroundColor: primaryColor}}
      >
        {canAny(
          PortalPermissions.administracao.usuarios.acessar,
          PortalPermissions.administracao.empresas.acessar
        ) && (
          <SubMenu key="comercial" title="Comercial" icon={<UserOutlined />}>
            {can(PortalPermissions.administracao.usuarios.acessar) && (
              <Item key="comercial-1" icon={<FiUsers />}>
                <Link to="/usuarios">
                  Usuários
                </Link>
              </Item>
            )}
            {can(PortalPermissions.administracao.empresas.acessar) && (
              <Item icon={<IdcardOutlined />} key="business">
                <Link to="/empresas">
                  Empresas
                </Link>
              </Item>
            )}
          </SubMenu>
        )}

        <SubMenu key="repasses" title="Transações e Repasses" icon={<BiTransfer />}>
          {can(PortalPermissions.transacoes.vendas.acessar) && (
            <Item icon={<VscLiveShare />} key="painelVendas">
              <Link to="/painel-de-vendas">
                Vendas
              </Link>
            </Item>
          )}
          {can(PortalPermissions.transacoes.recebiveis.acessar) && (
            <Item icon={<VscLiveShare />} key="painelRecebiveis">
              <Link to="/painel-de-recebiveis">
                Recebíveis
              </Link>
            </Item>
          )}
        </SubMenu>

        {/*<SubMenu
          key="detalheLiquidacao"
          title="Detalhamento Liquidação"
          icon={<BiMoneyWithdraw />}
        >
          <Item icon={<GiReceiveMoney />} key="detalheRecebiveis">
            <Link to="/detalhe-liquidacao-recebiveis">
              Recebíveis
            </Link>
          </Item>
        </SubMenu> */}
        

        {can(PortalPermissions.financeiro.politicasCobranca.acessar) && (
          <Item icon={<FaRegFilePowerpoint />} key="cadastro-geral-1">
            <Link to="/cadastro-geral/politicas-cobranca">
              Políticas de Cobrança
            </Link>
          </Item>
        )}
        {can(PortalPermissions.terminais.phoebus.acessar) && (
          <Item icon={<FaMobileScreenButton />} key="terminaisPhoebus">
            <Link to="/terminaisPhoebus">
              Terminais
            </Link>
          </Item>
        )}

        <SubMenu key="gestaoCobranca" title="Gestão de Cobranças" icon={<CiMoneyBill/>}>
          {can(PortalPermissions.cobrancas.menu.acessar) && (
            <Item icon={<MdOutlinePointOfSale/>} key="menuCobrancas">
              <Link to="/menu-cobrancas">
                Menu de Cobranças
              </Link>
            </Item>
          )}
          {can(PortalPermissions.cobrancas.produtosContratados.acessar) && (
            <Item icon={<LiaFileSignatureSolid />} key="assinaturas">
              <Link to="/produtos">
                Produtos Contratados
              </Link>
            </Item>
          )}
          {can(PortalPermissions.cobrancas.cobrancaPontual.acessar) && (
            <Item icon={<FaHistory/>} key="cobrancaAvulsa">
              <Link to="/cobranca-avulsa">
                Cobrança Pontual
              </Link>
            </Item>
          )}

          {can(PortalPermissions.cobrancas.historicoAntecipacao.acessar) && (
            <Item icon={<FaHistory />} key="historicoAntecipacao">
              <Link to="/historico-antecipacao">
                Histórico de Antecipações
              </Link>
            </Item>
          )}
          {can(PortalPermissions.cobrancas.chargebacks.acessar) && (
            <Item icon={<FaHandHoldingUsd />} key="chargeback">
              <Link to="/admin/chargeback">Chargebacks</Link>
            </Item>
          )}
        </SubMenu>

        {can(PortalPermissions.comercial.areaParceiro.acessar) && (
          <Item icon={<CiShoppingCart />} key="cadastro">
            <a href="https://www.jotform.com/app/252384120652653" target="_blank">
              Área do Parceiro
            </a>
          </Item>
        )}
        {
        /*<SubMenu
        key="efeitoContrato"
                  title="Efeitos de Contrato"
                  icon={<FaFileContract />}
                >
                  <Item icon={<FaFileCircleCheck  />} key="efeitoContrato">
                  <Link to="/admin/efeito-contrato">
                    Efeitos Cumpridos
                  </Link>
                </Item>
                </SubMenu> 
                */}
        

      </Menu>
    </Sider>
  );
};
export default SideMenu;
